//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line object-curly-newline
import { mdiKeyOutline, mdiLockOpenOutline, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
// eslint-disable-next-line import/no-cycle
import { changePassword } from '@api'
import { error, success } from '@core/utils/toasted'
import { useUtils } from '@core/libs/i18n'
import { useRouter } from '@core/utils'
import { required, confirmedValidator } from '@core/utils/validation'
import useCryptoJs from '@/@core/utils/useCryptoJs'

export default {
  setup() {
    const isCurrentPasswordVisible = ref(false)
    const isNewPasswordVisible = ref(false)
    const isCPasswordVisible = ref(false)
    const currentPassword = ref(null)
    const newPassword = ref(null)
    const cPassword = ref(null)
    const form = ref(null)
    const { router } = useRouter()
    const { userData } = useCryptoJs()
    const { t } = useUtils()

    const changePass = async () => {
      if (form.value.validate()) {
        const response = await changePassword(userData.value.username, currentPassword.value, newPassword.value)
        if (response.ok) {
          success(response.message)
          router.push('/')
        } else {
          error(response.message.text)
        }
      }
    }

    const cancelAction = () => {
      form.value.reset()
      router.go(-1)
    }

    return {
      isCurrentPasswordVisible,
      isNewPasswordVisible,
      currentPassword,
      isCPasswordVisible,
      newPassword,
      cPassword,
      form,

      changePass,
      cancelAction,

      validators: {
        required,
        confirmedValidator,
      },

      // i18n
      t,

      icons: {
        mdiKeyOutline,
        mdiLockOpenOutline,
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
    }
  },
}
